export default __webpack_public_path__ + "3e3a268c5284b4b5cc83e4208d3c1c39.svg";